import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Grid, Typography } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import LoaderContainer from "../../components/LoaderContainer";
import api from "../../globals/axios";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomButton from "../../components/Custom/CustomButton";
import { useTranslation } from "react-i18next";
import SubmittingPopup from "../../components/Custom/FormSubmitPopup";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../components/Alert";

export default function TaskDetails() {
  const { taskId } = useParams();
  const [task, setTask] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const [actionPerform, setActionPerform] = useState(false);
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  useEffect(() => {
    const fetchTaskDetails = async () => {
      try {
        const response = await api.get(
          `/programs/farmer-tasks/?task_id=${taskId}`
        );
        setTask(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching task details:", error);
        setLoading(false);
      }
    };

    fetchTaskDetails();
  }, [taskId]);

  const taskFields = [
    { label: "Name", value: task?.name },
    { label: "Description", value: task?.description },
    { label: "Start Date", value: task?.start_date },
    { label: "Due Date", value: task?.due_date },
  ];

  const handleAction = (action) => {
    setActionPerform(true);
    api
      .post(`/programs/update-task-action-status/`, {
        task_id: taskId,
        action_status: action,
      })
      .then((res) => {
        console.log("Action performed successfully:", res.data);
        showAlert(
          "success",
          `${
            action === "WILLING" ? "You have chose this task" : "Rejected"
          } Successfully`
        );
        setActionPerform(false);
        setTimeout(() => {
          navigate("/farmer/program-input");
        }, 1500);
      })
      .catch((error) => {
        setActionPerform(false);
        const errorMessage =
          error.response?.data?.error || "An error occurred. Please try again.";
        showAlert("error", errorMessage);
      });
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="md">
          {task && (
            <>
              <CustomTitle>Task Details</CustomTitle>
              <Grid container spacing={2} mt={2}>
                {taskFields.map((field, index) => (
                  <Grid item xs={12} key={index}>
                    <Typography variant="subtitle1">
                      <strong>{field.label}:</strong> {field.value || "-"}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </>
          )}
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <CustomButton
                hideIcon
                sx={{ mt: 2 }}
                onClick={() => handleAction("WILLING")}
                backgroundColor="#4CAF50"
              >
                {t("Willing")}
              </CustomButton>
            </Grid>
            <Grid item xs={6}>
              <CustomButton
                hideIcon
                sx={{ mt: 2 }}
                backgroundColor="#CF5C5C"
                onClick={() => handleAction("DECLINED")}
              >
                {t("Decline")}
              </CustomButton>
            </Grid>
          </Grid>
        </Container>
        {actionPerform && <SubmittingPopup title="Progress" />}
      </LoaderContainer>
    </>
  );
}
